export const QueryConstants = {
  getTeamManagementUsers: "getTeamManagementUsers",
  getSingleUser: "getSingleUser",
};
